import React, { useEffect, useState } from "react";

import { getCourses, getUserSwimlanes } from "services";

import { recordPageView, useCancelAsyncOnUnmount, useParams, useTranslation } from "utils";

import { Col, MainPage, Row } from "components";

import { Swimlane } from "pages/app/search/components/Swimlane";

export const Knowledge = () => {
  const { t } = useTranslation(["search", "meta", "modules"]);
  const { term } = useParams();

  const [loading, setLoading] = useState(true);
  const [courses, setCourses] = useState([]);
  const [swimlanes, setSwimlanes] = useState([]);
  const [share] = useState({
    title: term ? `${t("meta:knowledge.title")} · ${term.replace(/-/g, " ")}` : t("meta:knowledge.title"),
    summary: term ? `${term.replace(/-/g, " ")} · ${t("meta:knowledge.description")}` : t("meta:knowledge.description"),
    link: `${process.env.REACT_APP_FARM_URL}/search`,
    image: `${process.env.REACT_APP_FARM_URL}/images/misc/share.png`,
  });
  const signal = useCancelAsyncOnUnmount()();

  const loadCourses = () => {
    getCourses({
      signal,
    }).then((res) => {
      setCourses(res);
    });
  };

  const loadSwimlanes = () => {
    getUserSwimlanes({
      signal,
    })
      .then((res) => {
        setSwimlanes(res);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadSwimlanes();
    loadCourses();
    recordPageView("search", "search");
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"search"} share={share}>
      <Row>
        <Col>
          <h2>{t("title.articles")}</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          {swimlanes.map((swimlane, index) => (
            <Swimlane key={index} courses={courses} swimlane={swimlane} />
          ))}
        </Col>
      </Row>
    </MainPage>
  );
};
